export const ALERT_MODE_OK = 'ALERT_MODE_OK';
export const ALERT_MODE_YES = 'ALERT_MODE_YES';
export const ALERT_MODE_YES_NO = 'ALERT_MODE_YES_NO';
export const ALERT_MODE_CUSTOM = 'ALERT_MODE_CUSTOM';
export const ALERT_MODE_INFO = 'ALERT_MODE_INFO';
